import { trimWithSingleSpace } from 'common/trimWithSingleSpace';
import { evolve } from 'ramda';

const transformation = {
  firstName: trimWithSingleSpace,
  lastName: trimWithSingleSpace,
};

export const formatUserName = (user: any) => evolve(transformation, user);
